import { defineComponent as t, openBlock as s, createElementBlock as o, mergeProps as l, renderSlot as r } from "vue";
import "./ghl-ui.es227.js";
const a = t({
  name: "UIDisplaySmSemibold",
  inheritAttrs: !1
}), m = t({
  ...a,
  setup(n) {
    return (e, i) => (s(), o("div", l(e.$attrs, { class: "hl-display-sm-semibold" }), [
      r(e.$slots, "default")
    ], 16));
  }
}), c = m;
export {
  c as default
};
